import {Component, ElementRef, HostListener, OnDestroy, ViewChild, ViewEncapsulation} from '@angular/core';
import {GlobalMessageService, GlobalMessageType, TranslationService} from '@spartacus/core';
import {ICON_TYPE, LaunchDialogService} from '@spartacus/storefront';
import {BehaviorSubject, Observable, Subscription} from 'rxjs';
import {first} from 'rxjs/operators';
import {UigActiveCartService} from 'src/app/services/uig-active-cart.service';
import {UigCartService} from '../../uig-cart.service';
import {MultiCartService} from '@spartacus/cart/base/core';

@Component({
    selector: 'app-uig-cart-notes-dialog',
    templateUrl: './uig-cart-notes-dialog.component.html',
    styleUrls: ['./uig-cart-notes-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class UigCartNotesDialogComponent implements OnDestroy{

    public readonly eIconTypes = ICON_TYPE;
    public entryNumber: number;
    public note = '';
    public cartId: string;
    private updateCartEntryNote$: Observable<Object>;
    public isLoading$ = new BehaviorSubject(false);

    @ViewChild('dialog', {read: ElementRef})
    dialog: ElementRef;
    private subscription: Subscription = new Subscription();

    constructor(
        private el: ElementRef,
        private uigCartService: UigCartService,
        private uigActiveCartService: UigActiveCartService,
        private multiCartService: MultiCartService,
        private translationService: TranslationService,
        private globalMessageService: GlobalMessageService,
        private launchDialogService: LaunchDialogService,
    ) {
        this.subscription.add(
            this.launchDialogService.data$.subscribe(
                (dialogData) => {
                    this.entryNumber = dialogData.entryNumber;
                    this.cartId = dialogData.cartId;
                    this.note = dialogData.note;
                }
            )
        );
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    protected onSuccess(response): void {
        this.multiCartService.reloadCart(this.cartId);
        this.launchDialogService.closeDialog(response);
        this.translationService
            .translate('notes.updateSuccess')
            .pipe(first())
            .subscribe((text) => {
                this.globalMessageService.add(text, GlobalMessageType.MSG_TYPE_CONFIRMATION);
            });
    }

    protected onError(err): void {
        this.multiCartService.reloadCart(this.cartId);
        this.launchDialogService.closeDialog(err);
        this.translationService
            .translate('notes.errorLabel', {errMsg: err})
            .pipe(first())
            .subscribe((text) => {
                this.globalMessageService.add(text, GlobalMessageType.MSG_TYPE_ERROR);
            });
    }

    public onSubmit(): void {
        this.isLoading$.next(true);
        this.updateCartEntryNote$ = this.uigCartService.updateCartEntryNote(this.entryNumber, this.note, this.cartId);
        this.updateCartEntryNote$.subscribe({
            next: (response) => {
                this.onSuccess(response);
                this.isLoading$.next(false);
            },
            error: (err) => {
                this.onError(err);
                this.isLoading$.next(false);
            }
        });
    }

    dismissModal(reason?: any): void {
        this.launchDialogService.closeDialog(reason);
    }

    @HostListener('click', ['$event'])
    handleClick(event: UIEvent): void {
        if ((event.target as any).tagName === this.el.nativeElement.tagName) {
            this.dismissModal('Cross click');
        }
    }


}
